var map = {
	"./Pillbox credentials.png": 6234,
	"./add org region.png": 61,
	"./adherence calender.png": 4118,
	"./create designation.png": 2822,
	"./dashboard.png": 1617,
	"./login.png": 5030,
	"./menu-1.png": 7217,
	"./menu-2.png": 1895
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9705;